module.exports = __webpack_public_path__ + "img/single-neutral-actions-mail.7f917ec3.svg";